// Shared detection for threads that are workflow RUNS (as opposed to normal chats).
// A thread created by a workflow run. New runs are prefixed "⚡ " (set server-side at
// every creation site); the legacy patterns catch runs created before that marker.
// Extracted from Sidebar.tsx so ChatView can give workflow-run threads a distinct UI.
export const LEGACY_RUN_TITLE = /^(whatsapp|telegram|slack|discord|routine)\s*·/i;

export function isWorkflowRunThread(title: string | null | undefined): boolean {
  const t = (title ?? "").trim();
  return t.startsWith("⚡") || LEGACY_RUN_TITLE.test(t);
}
